import { Button, message } from 'antd';
import React from 'react';

const AuthFailedComponent = (): any => {
  return (
    <React.Fragment>
      <span data-testid="auth-network-err">Login error. Please write to <a className="custom-action-link" href="mailto:care@ihx.in">
        care@ihx.in
      </a>.
        One of our agents will assist you.
      </span>
      <div className="text-right">
        <Button className="p-0 h-auto" danger={true} type="text" onClick={(): any => message.destroy()}>
          Close
        </Button>
      </div>
    </React.Fragment>
  );
};
export default AuthFailedComponent;
